module.exports = {
	"bidHistory": "Historique des enchères",
	"number": "Nombre de lots :",
	"shareThis": "Partager ce lot",
	"status": {
		"cancelled": "Annulé",
		"open": "Ouvert",
		"sold": "Vendu"
	},
	"underApproval": {
		"name": "Sous approbation",
		"description": "Ce lot requiert approbation une fois vendu."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/lot.json5
// module id = 1991
// module chunks = 6